const PENGUIN_ACCOUNT_TYPE = {
  MAKER: 1,
  SALON: 2
}

export default {
  PENGUIN_ACCOUNT_TYPE
}
